import { render, staticRenderFns } from "./EntityBoardView.vue?vue&type=template&id=27d7f906&scoped=true"
import script from "./EntityBoardView.vue?vue&type=script&lang=js"
export * from "./EntityBoardView.vue?vue&type=script&lang=js"
import style0 from "./EntityBoardView.vue?vue&type=style&index=0&id=27d7f906&prod&scoped=true&lang=scss"
import style1 from "./EntityBoardView.vue?vue&type=style&index=1&id=27d7f906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7f906",
  null
  
)

export default component.exports